import { Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import PageBreakNodeView from './PageBreakNodeView.vue';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        pageBreak: {
            /** Insert a page break block at the current position. */
            insertPageBreak: () => ReturnType;
        };
    }
}

export const PageBreakExtension = Node.create({
    name: 'pageBreak',

    group: 'block',
    atom: true,
    selectable: true,
    draggable: true,

    parseHTML() {
        return [{ tag: 'div[data-page-break]' }];
    },

    renderHTML() {
        return ['div', { 'data-page-break': '', class: 'page-break' }];
    },

    addNodeView() {
        return VueNodeViewRenderer(PageBreakNodeView);
    },

    addCommands() {
        return {
            insertPageBreak:
                () =>
                ({ chain }) => {
                    return chain()
                        .focus()
                        .insertContent({ type: 'pageBreak' })
                        .run();
                },
        };
    },
});
